var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLumaAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 500,
    viewBox: "0 0 1200 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1200V500H0V0Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.065 181.33L285 112.675V387.34L166.065 318.67V181.33Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285 387.34L166.065 318.67L285 250L403.935 318.67L285 387.34Z",
    fill: "url(#paint0_linear_1_112)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285 387.34L166.065 318.67L285 250L403.935 318.67L285 387.34Z",
    fill: "url(#paint1_linear_1_112)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M166.065 181.33L285 112.675V387.34L166.065 318.67V181.33Z",
    fill: "url(#paint2_linear_1_112)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M285 387.34L166.065 318.67L285 250L403.935 318.67L285 387.34Z",
    fill: "url(#paint3_linear_1_112)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M166.065 181.33L285 112.675V387.34L166.065 318.67V181.33Z",
    fill: "url(#paint4_linear_1_112)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M461.672 205.048H473.768V295.768H520.424V307H461.672V205.048ZM610.136 268.12C610.136 273.688 609.416 278.968 607.976 283.96C606.632 288.952 604.424 293.368 601.352 297.208C598.376 300.952 594.44 303.976 589.544 306.28C584.648 308.488 578.696 309.592 571.688 309.592C564.68 309.592 558.728 308.488 553.832 306.28C548.936 303.976 544.952 300.952 541.88 297.208C538.904 293.368 536.696 288.952 535.256 283.96C533.912 278.968 533.24 273.688 533.24 268.12V205.048H545.336V266.392C545.336 270.52 545.768 274.504 546.632 278.344C547.496 282.184 548.936 285.592 550.952 288.568C552.968 291.544 555.656 293.944 559.016 295.768C562.376 297.496 566.6 298.36 571.688 298.36C576.776 298.36 581 297.496 584.36 295.768C587.72 293.944 590.408 291.544 592.424 288.568C594.44 285.592 595.88 282.184 596.744 278.344C597.608 274.504 598.04 270.52 598.04 266.392V205.048H610.136V268.12ZM635.063 205.048H653.063L687.623 284.968H687.911L722.759 205.048H740.327V307H728.231V221.464H727.943L691.367 307H684.023L647.447 221.464H647.159V307H635.063V205.048ZM798.823 205.048H810.199L853.543 307H839.431L829.063 281.944H778.087L767.575 307H753.895L798.823 205.048ZM804.295 220.6H804.007L782.839 270.712H824.455L804.295 220.6ZM940.292 205.048H951.668L995.012 307H980.9L970.532 281.944H919.556L909.044 307H895.364L940.292 205.048ZM945.764 220.6H945.476L924.308 270.712H965.924L945.764 220.6ZM1008.56 205.048H1020.66V307H1008.56V205.048Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_112",
    x1: 166.065,
    y1: 318.67,
    x2: 403.935,
    y2: 318.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A78DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_112",
    x1: 166.065,
    y1: 318.67,
    x2: 403.935,
    y2: 318.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A78DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_112",
    x1: 300.51,
    y1: 371.8,
    x2: 196.65,
    y2: 155.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_112",
    x1: 166.065,
    y1: 318.67,
    x2: 403.935,
    y2: 318.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A78DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_112",
    x1: 300.51,
    y1: 371.8,
    x2: 196.65,
    y2: 155.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumaAiLogo);
export default __webpack_public_path__ + "static/media/LumaAILogo.bcd3754e1fa20d154947a10b83f25bb8.svg";
export { ForwardRef as ReactComponent };